import React from 'react'
import styled from 'styled-components'
import { useMe } from '../common/src/hooks/usersHooks'
import { userHelper } from '../common/src/helpers'
import { SERVER_URLS } from '../common/src/constants'

const Frame = styled.iframe`
  width: 100%;
  height: 100%;
`

export const withBusiness = ChildComponent => props => {
  const me = useMe()
  const premiumLevel = userHelper.getPremiumLevel(me)
  if (premiumLevel >= 2) {
    return <ChildComponent {...props} />
  }
  return <Frame src={SERVER_URLS.BUSINESS_REQUIRED}></Frame>
}
